import * as GroupType from 'constants/GroupType';

const BANDY_GROUP_MAP = {};

BANDY_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
BANDY_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
BANDY_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;

export default BANDY_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Bandy/GroupMap.js